import { configureStore } from "@reduxjs/toolkit";
import radioReducer from "./slices/radioSlice";
import numberReducer from "./slices/numberSlice";
import checkboxReducer from "./slices/checkboxSlice";

const store = configureStore({
  reducer: {
    radio: radioReducer,
    number: numberReducer,
    checkbox: checkboxReducer,
  },
});

export default store;
